module.exports = __webpack_public_path__ + "img/credit4.fb585b28.png";